module.exports = __webpack_public_path__ + "static/media/Arrow.b58fef20.svg";